import {
  FormattedDate,
  FormattedMessage,
  FormattedNumber,
  FormattedTime,
  useIntl,
} from "react-intl";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { selectPlayer } from "../../../features/player/playerSlice";
import MovementAtlasBetData from "./MovementAtlasBetData";
import { MovementProps } from "./MovementPaypal";
import PrintPlacebetData from "./PrintPlacebetData";

const PrintPlacebet: React.FC<MovementProps> = ({ movement }) => {
  const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
  const player = useAppSelector(selectPlayer);
  const intl = useIntl();
  const placebetData = JSON.parse(JSON.parse(movement.provider_hook));

  return (
    <table className="movement-table-detail placebet-table-detail">
      <thead>
        <tr>
          <th colSpan={2}>
            <FormattedMessage id="detail" /> <FormattedMessage id="ticket" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>ID</td>
        </tr>
        <tr>
          <td>{movement.id}</td>
        </tr>
        <tr>
          <td>
            <FormattedMessage id="date.and.time.of.issue" />
          </td>
        </tr>
        <tr>
          <td>
            {<FormattedDate value={placebetData.timestamp} />}&nbsp;
            <FormattedTime value={placebetData.timestamp} />
          </td>
        </tr>
        <tr>
          <td>
            <FormattedMessage id="ticket.amount" />
          </td>
        </tr>
        <tr>
          <td>
            <FormattedNumber
              value={movement.amount}
              style="currency"
              currency={movement.valute}
            />
          </td>
        </tr>
        <tr>
          <td>
            <FormattedMessage id="maximum.potential.payout" />
          </td>
        </tr>
        <tr>
          <td>
            <FormattedNumber
              value={placebetData.potentialWin}
              style="currency"
              currency={movement.valute}
            />
          </td>
        </tr>

        <tr>
          <td colSpan={2}>
            {movement.provider_hook_event == "PLACEBET" && (
              <PrintPlacebetData
                ticketsData={placebetData}
                currency={movement.valute}
              />
            )}

            {movement.provider_hook_event == "ATLASBET" && (
              <MovementAtlasBetData
                ticketsData={placebetData}
                currency={movement.valute}
              />
            )}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default PrintPlacebet;
